import {
  DEFAULT_LANG,
  getLangFromPath,
  getLangPathPrefix,
} from "@/utils/langPath";

function getCurrentLang() {
  if (typeof window === "undefined") {
    return DEFAULT_LANG;
  }
  return localStorage.lang || getLangFromPath() || DEFAULT_LANG;
}

function getLocal() {
  return getLangPathPrefix(getCurrentLang());
}

const domain = (str) => {
  const port = window.location.port;
  if (window.location.hostname == "localhost") {
    return "";
  }
  const domain = window.location.hostname.split(".");
  if (domain.length <= 2) {
    return (
      window.location.protocol +
      "//" +
      str +
      "." +
      domain.join(".") +
      `${port ? ":" + port : ""}`
    );
  }
  return (
    window.location.protocol +
    "//" +
    str +
    "." +
    [domain[domain.length - 2], domain[domain.length - 1]].join(".") +
    `${port ? ":" + port : ""}`
  );
};

function buildRouteMap() {
  const local = getLocal();
  const lang = getCurrentLang();

  return {
    index: `${local}`,
    entry: `/`,
    login: `${domain("www")}${local}/login`,
    register: `${domain("www")}${local}/register`,
    forgot: `${local}/forgot`,
    reset: `${local}/reset`,

    app_tv: `${domain("www")}${local}/app_tv`,

    labs: `${local}/labs`,

    market: `${domain("www")}${local}/market`,
    otc: `${domain("www")}${local}/express`,
    c2c: `${domain("otc")}${local}`,
    trade: `${domain("www")}${local}/trade`,
    futures: `${domain("futures")}${local}/trade`,
    kol: `${domain("futures")}${local}/strategy-bot`,
    innovation: `${domain("www")}${local}/innovation`,
    bonus: `${domain("activity")}${local}/bonus`,
    agent: `${domain("activity")}${local}/global-agent`,

    download: `${domain("www")}${local}/app-download`,
    totalAssets: `${domain("www")}${local}/wallet/overview`,
    exchangeAccount: `${domain("www")}${local}/wallet/main`,
    otcAccount: `${domain("www")}${local}/wallet/funding`,
    coAccount: `${domain("futures")}${local}/wallet/futures`,
    kolAssets: `${domain("futures")}${local}/wallet/strategy-bot`,
    financeAssets: `${domain("www")}${local}/wallet/deposit-treasure`,

    exchangeOrder: `${domain("www")}${local}/order/exchange`,
    otcOrder: `${domain("www")}${local}/order/funding`,
    coOrder: `${domain("www")}${local}/order/futures`,
    financeOrder: `${domain("www")}${local}/order/finance`,
    message: `${domain("www")}${local}/mesage`,
    noticeInfo: `${domain("www")}${local}/noticeInfo`,
    personal_userManagement: `${domain("www")}${local}/my/user-management`,
    myrate: `${domain("www")}${local}/my-rate`,
    personal_leaglTenderSet: `${domain("www")}${local}/my/leagl-tenderSet`,
    inviteFriends: `${domain("www")}${local}/invite-friends`,
    personal_apiManagement: `${domain("www")}${local}/my/api-management`,
    coupon_center: `${domain("www")}${local}/my/coupon-center`,

    cmsApply: `${domain("www")}${local}/support/listing`,
    agentApply:
      lang == "zh_CN"
        ? `https://forms.gle/zU3rQyGG3T6aD24r5`
        : lang == "zh_TW"
          ? "https://forms.gle/1bcmeWiSGjBHKRen7"
          : "https://forms.gle/2MJRwqqdSkdn5pubA",
    c2cApply: `${domain("otc")}${local}/company-application`,

    aboutUs: `${domain("www")}${local}/support/aboutus`,
    help:
      lang == "zh_CN"
        ? "https://vooxhelp.zendesk.com/hc/zh-cn"
        : "https://vooxhelp.zendesk.com/hc/en-us",
    fee: `${domain("www")}${local}/support/fee`,

    agreement: `${domain("www")}${local}/support/useragreement`,
    privacy: `${domain("www")}${local}/support/privacypolicy`,
    disclaimer: `${domain("www")}${local}/support/AML`,
    official: `${domain("www")}${local}/official`,
  };
}

const route_map = new Proxy(
  {},
  {
    get(_, prop) {
      return buildRouteMap()[prop];
    },
  },
);

const need_login = [];

export default route_map;

export { need_login, buildRouteMap, getCurrentLang };
